import React from "react";

const ItemForm = ({ children, type = "text", value, ...otherProps }) => (
  <div>
    <input type={type} value={value} {...otherProps} />
  </div>
);

export default ItemForm;
